import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { TranslocoService } from "@ngneat/transloco";
import { OAuthService } from "angular-oauth2-oidc";
import { JwksValidationHandler } from "angular-oauth2-oidc-jwks";
import * as waves from "node-waves";
import { distinctUntilChanged, filter, map } from "rxjs/operators";
import { authConfig } from "./auth.config";
import { AppConfigService, AuthService } from "./core";
import { ProfileModel } from "./core/models/profile-model";
import { AccountService } from "./core/services/account.service";
import { PlatformTypes } from "./models";
import { Unsubscriber } from "@app/shared/components";
import initHelpHero, { HelpHero } from "helphero";
import { environment } from "../environments/environment";

@Component({ selector: "app-clearline", templateUrl: "app.component.html", styleUrls: ["app.component.scss"] })
export class AppComponent extends Unsubscriber implements OnInit {
  user: ProfileModel;
  loginOnly = false;
  platformTypes = PlatformTypes;
  get year() {
    return new Date().getFullYear();
  }

  constructor(
    private router: Router,
    private titleService: Title,
    private translateSvc: TranslocoService,
    private authService: AuthService,
    private accountService: AccountService,
    private configSvc: AppConfigService
  ) {
    super();
  }

  ngOnInit() {
    waves.init();
    this.authService.configureOidc();
    this.loadHelpHero();
    this.setBrowserTitle();
  }

  private loadHelpHero(): void {
    const helpHeroAppId = environment.helpHeroAppId;

    if (helpHeroAppId) {
      const helpHero: HelpHero = initHelpHero(helpHeroAppId);

      this.sub = this.accountService.userChanged$
        .pipe(
          filter((user: ProfileModel) => !!user?.sub),
          map((user: ProfileModel) => user.sub),
          distinctUntilChanged()
        )
        .subscribe((userSub: string) => {
          helpHero.identify(userSub);
        });
    }
  }

  private setBrowserTitle() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route: ActivatedRoute = this.router.routerState.root;
          let routeTitle = "";
          while (route!.firstChild) {
            route = route.firstChild;
          }
          if (route.snapshot.data["title"]) {
            routeTitle = route!.snapshot.data["title"];
          }
          return routeTitle;
        })
      )
      .subscribe((title: string) => {
        if (title) {
          this.titleService.setTitle(`${this.configSvc.appData.title} - ${this.translateSvc.translateObject("common.menu." + title)}`);
        }
      });
  }
}
